<template lang="html">
  <div>
    <slot/>
  </div>
</template>

<script>

export default {
  props: {
    collapsed: {
      type: [String, Boolean],
      default: false
    },
    collapsable: {
      type: [String, Boolean],
      default: false
    }
  },

  data(){
    let collapsed = this.collapsed
    let collapsable = this.collapsable

    if(typeof collapsed === 'string') collapsed = collapsed === 'true'
    if(typeof collapsable === 'string') collapsable = collapsable === 'true'

    if(window.innerWidth > 768) return {expanded: true, togglable: collapsable}
    return {
      expanded: !collapsed,
      togglable: collapsable
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/panel/Panel.vue